import React from 'react';

// ==========================================
// 🛑 ASA NOTIFICATION POP-UP (DISABLED PER USER REQUEST)
// Untuk mengaktifkan kembali:
// 1. Uncomment seluruh kode di bawah
// 2. Set ASA_ENABLED = true di useAsaAlerts.js
// 3. Kembalikan Test Mode ke false (getDaysActive return diffDays)
// ==========================================

export default function AsaNotificationManager() {
  // ASA Notification System sedang dinonaktifkan.
  // Semua kode UI & logic dipertahankan di bawah untuk aktivasi di masa depan.
  // Discord reporting (sendDiscordReport) tetap tersedia via lib/discordAsa.js
  return null;
}

/*
==========================================
PRESERVED CODE - DO NOT DELETE
Aktifkan kembali jika user berkata:
"kembalikan asa notifikasi"
==========================================

import React, { useState, useEffect } from 'react';
import { useSession } from '@/lib/SessionContext';
import { Sparkles, AlertTriangle, X, Check, ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { sendDiscordReport } from '@/lib/discordAsa';
import { Button } from '@/components/ui/button';
import { useAsaAlerts } from '@/hooks/useAsaAlerts';

export default function AsaNotificationManager() {
  const { member } = useSession();
  const navigate = useNavigate();
  const { alerts, dismissAlert } = useAsaAlerts();
  const [activeAlert, setActiveAlert] = useState(null);

  const handleEscalation = async (alert, reason) => {
    dismissAlert(alert.id);
    
    if (reason === 'teledor') {
      await sendDiscordReport('WORKSPACE', 'Peringatan ASA - Teledor', `Username: ${member.full_name} (${member.id}) melaporkan keteledoran atas teguran:\n*"${alert.message}"*\n\nCatatan ASA: Tolong dinasihati ya, jangan sampai jadi kebiasaan!`, '#EAB308', member);
    } else {
      await sendDiscordReport('WORKSPACE', 'Laporan ASA - Data Anomali', `Username: ${member.full_name} (${member.id}) melaporkan ada anomali sistem/data terkait peringatan:\n*"${alert.message}"*\n\nCatatan ASA: Developer mohon segera check ke tkp!`, '#EF4444', member);
    }
  };

  useEffect(() => {
    const visibleAlerts = alerts.filter(a => a.daysActive > 0);
    if (visibleAlerts.length > 0) {
      const escalated = visibleAlerts.find(a => a.daysActive >= 3);
      setActiveAlert(escalated || visibleAlerts[0]);
    } else {
      setActiveAlert(null);
    }
  }, [alerts]);

  if (!activeAlert) return null;

  const isEscalated = activeAlert.daysActive >= 3;

  return (
    <div className={`fixed z-[9999] p-4 animate-in fade-in slide-in-from-bottom-4 duration-500 shadow-2xl rounded-2xl border ${isEscalated ? 'bottom-1/2 translate-y-1/2 left-1/2 -translate-x-1/2 w-[90%] max-w-md bg-white border-red-200' : 'bottom-6 right-6 w-80 bg-gradient-to-r from-[#F9F5EC] to-[#FFFDF9] border-[#E6D5B8]'}`}>
      
      {!isEscalated && (
        <button onClick={() => dismissAlert(activeAlert.id)} className="absolute top-3 right-3 text-slate-400 hover:text-slate-700">
          <X className="w-4 h-4" />
        </button>
      )}

      <div className="flex gap-4 mb-3">
        <div className={`w-10 h-10 rounded-full flex items-center justify-center shrink-0 shadow-inner ${isEscalated ? 'bg-red-100' : 'bg-gradient-to-br from-[#D4AF37] to-[#8C6208]'}`}>
          {isEscalated ? <AlertTriangle className="w-5 h-5 text-red-600" /> : <Sparkles className="w-5 h-5 text-white" />}
        </div>
        <div>
          <h3 className={`text-xs font-black uppercase tracking-wider mb-0.5 ${isEscalated ? 'text-red-700' : 'text-[#8C6208]'}`}>
            {isEscalated ? 'Peringatan Tegas ASA' : 'ASA Mengingatkan'}
          </h3>
          <p className="text-sm font-medium text-[#302621] leading-relaxed pr-4">
            {isEscalated ? (
              <>
                <p className="mb-2 text-[#302621]">Halo, ini udah 3 hari lho teguran soal ini didiemin aja. ASA nanya serius nih, ini datanya yang memang error (anomali) atau kamunya yang lagi teledor?</p>
                <div className="bg-red-50 p-2 rounded border border-red-100 text-xs text-red-800 font-medium italic">
                  "{activeAlert.message}"
                </div>
              </>
            ) : activeAlert.message}
          </p>
        </div>
      </div>

      {isEscalated ? (
        <div className="flex flex-col gap-2 mt-4 pt-4 border-t border-red-100">
          <Button variant="outline" onClick={() => handleEscalation(activeAlert, 'teledor')} className="w-full justify-start text-xs text-amber-700 border-amber-200 hover:bg-amber-50">
            😞 ASA maaf yaa, aku yang teledor kelupaan...
          </Button>
          <Button variant="outline" onClick={() => handleEscalation(activeAlert, 'anomali')} className="w-full justify-start text-xs text-red-700 border-red-200 hover:bg-red-50">
            🤖 Ini datanya yang error / anomali! Laporin dev dong.
          </Button>
        </div>
      ) : (
        <div className="mt-3 flex justify-end">
          <Button size="sm" onClick={() => {
            navigate(activeAlert.link);
            dismissAlert(activeAlert.id);
          }} className="h-8 text-xs bg-[#8C6208] hover:bg-[#7A5506] text-white rounded-lg gap-2">
            Cek Sekarang <ArrowRight className="w-3 h-3" />
          </Button>
        </div>
      )}
    </div>
  );
}
*/
